import Helmet from "react-helmet";
import styled from "@emotion/styled";
import SideBar from "components/sidebar/Sidebar";
import { Link } from "react-router-dom";
import { useGetMyStatsQuery } from "generated/graphql";
import "assets/css/w3.css";
import NavBar from "components/navbar/NavBar";
import { useContext, useState } from "react";
import { LoggedInUserContext } from "contexts/user";
import { isEmpty } from "lodash";

const DashboardWrapper = styled.div`
  /* Side Navbar */

  .sponsor {
    width: 100;
    height: 30px;
    margin-top: 0px;
    margin-left: -5px;
  }

  .sidebar {
    width: 200px;
    height: 100%;
    background: #701129;
    padding: 30px 0px;
    position: fixed;
  }

  .side-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
    margin-left: 50px;
    /* margin-top: -20px; */
  }

  .search {
    width: 170px;
    height: 35px;
    margin-left: 15px;
  }

  .sidebar ul {
    list-style-type: none;
    margin-top: -10px;
  }

  .sidebar ul li {
    padding: 15px;
  }

  .sidebar ul li a {
    color: #ffffff;
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    margin-right: 35px;
  }

  /* Top Navbar */

  .profilePic img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  /* Game filter */

  .game-filter-container {
    margin-left: 250px;
  }

  .game-filter-container img {
    width: 100px;
    height: 134px;
    padding-right: 30px;
  }

  /* Tournament Calendar */

  .t_calendar {
    margin-left: 0px;
  }

  .month {
    padding: 70px 25px;
    width: 95%;
    background: #701129;
    text-align: center;
    margin-left: 0px;
  }

  ul {
    list-style-type: none;
  }

  .month ul {
    margin: 0;
    padding: 0;
  }

  .month ul li {
    color: white;
    font-size: 20px;
    text-transform: uppercase;
    letter-spacing: 3px;
  }

  .month .prev {
    float: left;
    padding-top: 10px;
  }

  .month .next {
    float: right;
    padding-top: 10px;
  }

  .weekdays {
    margin: 0;
    padding: 10px 0;
    background-color: #777;
    width: 95%;
    margin-left: 0px;
  }

  .weekdays li {
    display: inline-block;
    width: 13.6%;
    color: #fff;
    text-align: center;
  }

  .days {
    padding: 10px 0;
    background: #1d2029;
    margin: 0;
    width: 95%;
    margin-left: 0px;
  }

  .days li {
    list-style-type: none;
    display: inline-block;
    width: 13.6%;
    text-align: center;
    margin-bottom: 5px;
    font-size: 15px;
    color: #ffffff;
  }

  .days li .active {
    padding: 5px;
    background: #701129;
    color: white !important;
  }

  /* Tournament History */

  .t_title {
    margin-left: 250px;
    margin-top: 50px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin-left: 250px;
    margin-top: 30px;
    margin-bottom: 50px;
    background: #1d2029;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }

  td,
  th {
    border: 1px solid #7d7d7d;
    text-align: left;
    padding: 8px;
  }

  th {
    color: #7d7d7d;
  }

  .tourn_column {
    float: left;
    width: 75%;
    padding: 0 10px;
  }

  .pl_stats {
    width: 30%;
    margin-left: 0px;
    padding: 0 10px;
  }

  /* Remove extra left and right margins, due to padding */

  #dash_info {
    margin-top: 50px;
    margin-bottom: 50px;
  }

  /* Clear floats after the columns */

  #dash_info:after {
    content: "";
    display: table;
    clear: both;
  }

  /* Style the counter cards */

  .pl_card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    padding: 16px;
    text-align: center;
    background-color: #1d2029;
    border-radius: 5px;
  }

  .pl_card h3 {
    text-align: left;
    font-size: 20px;
    color: #7d7d7d;
  }

  .pl_card p {
    text-align: right;
    margin-left: 100px;
    margin-top: -40px;
  }

  .pl_card button {
    background-color: #701129;
    color: #ffffff;
    border-radius: 3px;
    border: 2px solid #701129;
    cursor: pointer;
  }

  /* Style the counter cards */

  .pl_card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    padding: 16px;
    text-align: center;
    background-color: #1d2029;
    border-radius: 5px;
  }

  .pl_card h3 {
    text-align: left;
    font-size: 20px;
  }

  .pl_card p {
    text-align: right;
    margin-left: 100px;
    margin-top: -40px;
  }

  .pl_card button {
    background-color: #701129;
    color: #ffffff;
    border-radius: 3px;
    border: 2px solid #701129;
    cursor: pointer;
  }

  @media (max-width: 858px) {
    /* Side Bar */
    .sidebar {
      width: 0%;
      height: 0%;
    }
    .search {
      display: none;
    }
    .side-logo {
      width: 50px;
      height: 50px;
      margin-top: -30px;
      margin-left: 5px;
    }
    .checkbtn {
      background-color: #1d2029;
      width: 70px;
      height: 50px;
      display: block;
      float: right;
      margin-right: 0px;
      margin-top: 0px;
    }
    .checkbtn i {
      padding-left: 20px;
      padding-right: 20px;
    }
    .sidebar ul {
      position: fixed;
      width: 100%;
      height: 100%;
      background: #701129;
      top: 70px;
      top: -100%;
      text-align: center;
      transition: all 0.5s;
    }
    #check:checked ~ .sidebar ul {
      top: 60px;
    }
    /* Top Navbar */
    .main_content {
      width: 100%;
      margin-left: 0px;
    }
    /* Filter by Game */
    .w3-bar {
      margin-left: 0px;
    }
    .w3-container {
      margin-left: 0px;
    }
    .pl_card {
      width: 300px;
    }
    /* Tournament Calendar */
    .t_calendar {
      margin-left: 20px;
    }
    /* Tournament History */
    .t_title {
      margin-left: 20px;
      margin-top: 50px;
    }
    table {
      margin-left: 20px;
    }
  }
`;

function DashboardPage() {
  const { data: myStats, loading: loadingMyStats } = useGetMyStatsQuery({ nextFetchPolicy: 'cache-first'});
  const me = useContext(LoggedInUserContext);
  const [activeSection, setActiveSection] = useState("");

  return (
    <DashboardWrapper>
      <Helmet>
        <title>Dashboard — Jiwe eSports</title>
      </Helmet>
      <div className="wrapper">
        <SideBar nickname={me?.nickname} isLoggedIn={!!me?.nickname} />
        {me && <NavBar nickname={me?.nickname} name={me?.name} />}
      </div>

      <div
        className="w3-bar "
        style={{
          marginLeft: "200px",
          backgroundColor: "#1D2029",
          marginTop: "20px",
        }}
      >
        {me &&
          me?.partyDetails
            .filter(({ key }) => key === "preferred_games")
            .map(({ value }) => JSON.parse(value!))
            .reduce((acc, val) => [...acc, ...val], [])
            .map((value: string) => (
              <button
                className="w3-bar-item w3-button"
                onClick={() => setActiveSection(value)}
              >
                {value}
              </button>
            ))}
      </div>

      {activeSection === "PUBG" && (
        <div className="w3-container city" style={{ marginLeft: "200px" }}>
          <div className="pl_stats">
            <h3>PUBG Stats</h3>
            <div className="pl_card">
              <h3>KDA: </h3>
              <p>3.27</p>
              <h3>W/L: </h3>
              <p>4.8</p>
              <h3>Game Record: </h3>
              <p>0.92</p>
              <h3>Total Cash Won: </h3>
              <p>Ksh 4000</p>
              <Link to={`/profile/${me?.nickname}/stats`}>
                <button>See Full Stats</button>
              </Link>
            </div>
          </div>
          <h2 className="t_calendar">Tournament Calendar</h2>
          <div className="month">
            <ul>
              <li className="prev">&#10094;</li>
              <li className="next">&#10095;</li>
              <li>
                August
                <br />
                <span style={{ fontSize: "18px" }}>2021</span>
              </li>
            </ul>
          </div>
          <ul className="weekdays">
            <li>Mo</li>
            <li>Tu</li>
            <li>We</li>
            <li>Th</li>
            <li>Fr</li>
            <li>Sa</li>
            <li>Su</li>
          </ul>

          <ul className="days">
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>
              <span className="active">4</span>
            </li>
            <li>5</li>
            <li>6</li>
            <li>7</li>
            <li>8</li>
            <li>9</li>
            <li>
              <span className="active">10</span>
            </li>
            <li>11</li>
            <li>12</li>
            <li>13</li>
            <li>14</li>
            <li>15</li>
            <li>16</li>
            <li>17</li>
            <li>18</li>
            <li>19</li>
            <li>20</li>
            <li>
              <span className="active">21</span>
            </li>
            <li>22</li>
            <li>23</li>
            <li>24</li>
            <li>25</li>
            <li>26</li>
            <li>
              <span className="active">27</span>
            </li>
            <li>28</li>
            <li>29</li>
            <li>30</li>
            <li>31</li>
          </ul>
        </div>
      )}
      {activeSection !== "PUBG" && !loadingMyStats && (
        <div className="w3-container city" style={{ marginLeft: "200px" }}>
          <div className="pl_stats">
            <h3>{activeSection} Stats</h3>
            <div className="pl_card">
              <h3>KDA: </h3>
              <p>
                {!isEmpty(myStats?.myStats?.scores) &&
                  myStats?.myStats?.scores?.global.kda}
              </p>
              <h3>W/L: </h3>
              <p>
                {!isEmpty(myStats?.myStats?.scores) &&
                  myStats?.myStats?.scores?.global.winLossRatio}
              </p>
              <h3>Game Record: </h3>
              <p>
                {!isEmpty(myStats?.myStats?.scores) &&
                myStats?.myStats?.scores?.global.matchesPlayed
                  ? myStats?.myStats?.scores?.global.wins /
                    myStats?.myStats?.scores?.global.matchesPlayed
                  : 0}
              </p>
              {/* <h3>Total Cash Won: </h3>
              <p>Ksh 2000</p> */}
              <Link to="/stats">
                <button>See Full Stats</button>
              </Link>
            </div>
          </div>
          <h2 className="t_calendar">Tournament Calendar</h2>
          <div className="month">
            <ul>
              <li className="prev">&#10094;</li>
              <li className="next">&#10095;</li>
              <li>
                August
                <br />
                <span style={{ fontSize: "18px" }}>2021</span>
              </li>
            </ul>
          </div>

          <ul className="weekdays">
            <li>Mo</li>
            <li>Tu</li>
            <li>We</li>
            <li>Th</li>
            <li>Fr</li>
            <li>Sa</li>
            <li>Su</li>
          </ul>

          <ul className="days">
            <li>1</li>
            <li>2</li>
            <li>3</li>
            <li>4</li>
            <li>5</li>
            <li>6</li>
            <li>
              <span className="active">7</span>
            </li>
            <li>8</li>
            <li>9</li>
            <li>10</li>
            <li>11</li>
            <li>12</li>
            <li>
              <span className="active">13</span>
            </li>
            <li>14</li>
            <li>15</li>
            <li>16</li>
            <li>17</li>
            <li>18</li>
            <li>19</li>
            <li>20</li>
            <li>21</li>
            <li>22</li>
            <li>
              <span className="active">23</span>
            </li>
            <li>24</li>
            <li>25</li>
            <li>26</li>
            <li>27</li>
            <li>28</li>
            <li>
              <span className="active">29</span>
            </li>
            <li>30</li>
            <li>31</li>
          </ul>
        </div>
      )}

      <div id="dash_info">
        <div className="tourn_column">
          <h2 className="t_title">Tournament History</h2>

          <table>
            <tr>
              <th>Date</th>
              <th>Rank</th>
              <th>Points</th>
              <th>KDA</th>
              <th>Cash Won</th>
            </tr>
            <tr>
              <td>12/6/21</td>
              <td>7th</td>
              <td>1600</td>
              <td>5.35</td>
              <td>Ksh 1,300</td>
            </tr>
            <tr>
              <td>18/6/21</td>
              <td>5th</td>
              <td>2300</td>
              <td>6.94</td>
              <td>Ksh 1,700</td>
            </tr>
            <tr>
              <td>21/6/21</td>
              <td>2nd</td>
              <td>2700</td>
              <td>7.08</td>
              <td>Ksh 1,500</td>
            </tr>
            <tr>
              <td>25/6/21</td>
              <td>1st</td>
              <td>3200</td>
              <td>7.24</td>
              <td>Ksh 1,200</td>
            </tr>
            <tr>
              <td>20/5/21</td>
              <td>3rd</td>
              <td>2700</td>
              <td>6.69</td>
              <td>Ksh 1,300</td>
            </tr>
            <tr>
              <td>15/5/21</td>
              <td>2nd</td>
              <td>2800</td>
              <td>4.08</td>
              <td>Ksh 1,500</td>
            </tr>
          </table>
        </div>
      </div>
    </DashboardWrapper>
  );
}

export default DashboardPage;
